<div class="container ">
  <div class="section">
    <div class="custom-text">
      On this page you will be able to allow an external user to connect to Upload Vallourec and authorize him to upload and share
      files for <b>14 days</b>.
    </div>
    <label for="email" class="label">Email</label>
    <div class="flex-space-between" style="align-items: center;">
      <div class="flex-grow-1">
        <input id="email" type="text" [formControl]="email" placeholder="Enter partner's email" class="input">
      </div>
      <button (click)="authorize()" class="vlr-large-cta-btn" style="margin-left: 16px; margin-top: 0; margin-bottom: 0;">
        Authorize User
      </button>
    </div>
    {{  response }}
  </div>

  <mat-table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" matSortActive="UserLastModifiedDate"
             matSortDirection="desc">

    <!-- File Name Column -->
    <ng-container matColumnDef="Username">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Username</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.Username}} </mat-cell>
    </ng-container>

    <!-- File UserCreateDate Column-->
    <ng-container matColumnDef="UserCreateDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Creation date</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.UserCreateDate | date : 'mediumDate'}} </mat-cell>
    </ng-container>

    <!-- File AuthorizedEndDate Column-->
    <ng-container matColumnDef="AuthorizedEndDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Authorization End Date</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{getAttribute(element, "custom:authorized") | date : 'mediumDate'}} </mat-cell>
    </ng-container>

    <!-- File UserStatus Column-->
    <ng-container matColumnDef="UserStatus">
      <mat-header-cell *matHeaderCellDef mat-sort-header> User status</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.UserStatus}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
      <mat-cell *matCellDef="let element" class="cell-align-right">
        <button class="vlr-ghost-btn vlr-icon-btn"
        (click)="removeAuthorization(element.Username)">
          <mat-icon fontSet="material-icons-outlined">chevron_right</mat-icon>
          <span>Remove authorization</span>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>


  <div class="d-flex justify-content-center">
    <div class="spinner-border m-4" role="status" *ngIf="flag_loader">
    </div>
    <div class="m-4" *ngIf="dataSource.data.length === 0 && !flag_loader">
      No data to show
    </div>
  </div>
</div>

